import { ZoneGeometryDto } from '../graphql/types';
import { useAgencyZonesQuery } from '../graphql/Agency/AgencyZones.generated';

type AgencyZonesResult = {
  agencyZones: ZoneGeometryDto[]
  loadingCouriers: boolean;
  refresh: () => Promise<void>;
}

const useAgencyZonesDataStore = (
  agencyId: string | null,
): AgencyZonesResult => {

  const {loading, data, refetch } = useAgencyZonesQuery({
    skip: !agencyId,
    variables: agencyId ? { agencyId } : undefined
  });

  const refresh = async () => {
    await refetch(
      agencyId ? { agencyId } : undefined
    );
  };

  if (data !== undefined) {
    return {
      agencyZones: data.AgencyZones,
      loadingCouriers: loading,
      refresh,
    };
  }

  return {
    agencyZones: [],
    loadingCouriers: loading,
    refresh,
  };
}

export default useAgencyZonesDataStore;